import "./locateUs.css";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import fb from "../../assets/locationAssets/fb.svg";
import insta from "../../assets/locationAssets/insta.svg";
import yt from "../../assets/locationAssets/yt.svg";
import wt from "../../assets/locationAssets/wa.svg";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Fix for default marker icons in React-Leaflet
const DefaultIcon = L.icon({
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});
L.Marker.prototype.options.icon = DefaultIcon;

const LocateUs = () => {
  const location = {
    lat: 17.317344,
    lng: 76.856921,
    address:
      "Floor, D, No.2-910/23/63, First, road, Tilak Nagar, Kusnoor, Kalaburagi, Karnataka 585105",
  };

  return (
    <>
      <div className="locateus-container">
        <hr style={{ width: "88%", border: "1px solid #BBBBBBBB" }} />
        <h2>Locate us Here</h2>
        <p className="location-address-text">{location.address}</p>
        <div className="map-container">
          <MapContainer
            center={[location.lat, location.lng]}
            zoom={15}
            className="map-container-inside"
          >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[location.lat, location.lng]}>
              <Popup>{location.address}</Popup>
            </Marker>
          </MapContainer>
        </div>
        <h2 className="connect-with-us-header">Connect With Us</h2>
        <div className="connect-social-media">
          <a href="#fb" className="contact-sm-icon">
            <img src={fb} alt="facebook" />
          </a>
          <a
            href="https://www.instagram.com/saraswati_pathashala/?utm_source=qr&igsh=YnZ6MGkyOWN2cGN0"
            className="contact-sm-icon"
          >
            <img src={insta} alt="instagram" />
          </a>
          <a href="#yt" className="contact-sm-icon">
            <img src={yt} alt="youtube" />
          </a>
          <a href="tel:+917090354555" className="contact-sm-icon">
            <img src={wt} alt="whatsapp" />
          </a>
        </div>
      </div>
    </>
  );
};

export default LocateUs;
